import React from "react";
import ClientSnapshotGraph1 from "../../Graphs/ClientSnapshotGraph1";
import ClientSnapshotGraph2 from "../../Graphs/ClientSnapshotGraph2";
import ClientSnapshotGraph3 from "../../Graphs/ClientSnapshotGraph3";
import ClientSnapshotGraph4 from "../../Graphs/ClientSnapshotGraph4";
import SmallLoader from "../../Common/smallLoader";
import { checkEmpty } from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import NodataFound from "../../../asset/images/No data available.svg";

function ClientSnapshotContent(props) {
  const Clientloader = props.loader;
  const id = props.id;
  const filterBy = props.filterBy;
  const active = filterBy === "monthly" ? "show active" : "";

  const AcqClients = props.AcqClients;
  const inActiveClients = props.inActiveClients;
  const topBrokClients = props.topBrokClients;
  const topClientsMTF = props.topClientsMTF;

  const AcqTradedClient = checkEmpty(AcqClients)
    ? // AcqClients === undefined || null
      "-"
    : // AcqClients.tradedclients === undefined || null
    checkEmpty(AcqClients.tradedclients)
    ? "-"
    : AcqClients.tradedclients;

  const AcqNotTradedWMargin = checkEmpty(AcqClients)
    ? // AcqClients === undefined || null
      "-"
    : checkEmpty(AcqClients.nottradedwmargin)
    ? //  AcqClients.nottradedwmargin === undefined || null
      "-"
    : AcqClients.nottradedwmargin;

  const AcqNotTradedWOMargin = checkEmpty(AcqClients)
    ? // AcqClients === undefined || null
      "-"
    : checkEmpty(AcqClients.nottradedwomargin)
    ? //  AcqClients.nottradedwomargin === undefined || null
      "-"
    : AcqClients.nottradedwomargin;

  const InActiveZeroClient = checkEmpty(inActiveClients)
    ? // inActiveClients === undefined || null
      "-"
    : checkEmpty(inActiveClients.zeroopclients)
    ? //  inActiveClients.zeroopclients === undefined || null
      "-"
    : inActiveClients.zeroopclients;

  const InActiveGreater30D = checkEmpty(inActiveClients)
    ? "-"
    : checkEmpty(inActiveClients.inactivegreaterthan30d)
    ? "-"
    : inActiveClients.inactivegreaterthan30d;
  const InactiveGreater60D = checkEmpty(inActiveClients)
    ? "-"
    : checkEmpty(inActiveClients.inactivegreaterthan60d)
    ? "-"
    : inActiveClients.inactivegreaterthan60d;

  const InActiveGreater90D = checkEmpty(inActiveClients)
    ? "-"
    : checkEmpty(inActiveClients.inactivegreaterthan90d)
    ? "-"
    : inActiveClients.inactivegreaterthan90d;

  const TopBrokingGreater15K = checkEmpty(topBrokClients)
    ? "-"
    : checkEmpty(topBrokClients.revenuegreaterthan15k)
    ? "-"
    : topBrokClients.revenuegreaterthan15k;

  const TopBrokingGreater10K = checkEmpty(topBrokClients)
    ? "-"
    : checkEmpty(topBrokClients.revenuegreaterthan10k)
    ? "-"
    : topBrokClients.revenuegreaterthan10k;

  const TopBrokingGreater5K = checkEmpty(topBrokClients)
    ? "-"
    : checkEmpty(topBrokClients.revenuegreaterthan5k)
    ? "-"
    : topBrokClients.revenuegreaterthan5k;

  const TopBrokingGreater1K = checkEmpty(topBrokClients)
    ? "-"
    : checkEmpty(topBrokClients.revenuegreaterthan1k)
    ? "-"
    : topBrokClients.revenuegreaterthan1k;

  const TopMtfClient = checkEmpty(topClientsMTF)
    ? "-"
    : checkEmpty(topClientsMTF.mtfclient)
    ? "-"
    : topClientsMTF.mtfclient;

  const AcqTotal = AcqNotTradedWMargin + AcqNotTradedWOMargin;

  // const ChartAcq = (AcqTradedClient / AcqTotal) * 100;
  const ChartAcqNotWmargin = (AcqNotTradedWMargin / AcqTotal) * 100;
  const ChartAcqNotWOmargin = (AcqNotTradedWOMargin / AcqTotal) * 100;

  const InActiveTotal =
    InActiveGreater30D + InactiveGreater60D + InActiveGreater90D;

  const ChartInActiveG30D = (InActiveGreater30D / InActiveTotal) * 100;
  const ChartInActiveG60D = (InactiveGreater60D / InActiveTotal) * 100;
  const ChartInActiveG90D = (InActiveGreater90D / InActiveTotal) * 100;

  const TopBrokingTotal =
    TopBrokingGreater15K +
    TopBrokingGreater10K +
    TopBrokingGreater5K +
    TopBrokingGreater1K;

  const TopBrokingG15K = (TopBrokingGreater15K / TopBrokingTotal) * 100;
  const TopBrokingG10K = (TopBrokingGreater10K / TopBrokingTotal) * 100;
  const TopBrokingG5K = (TopBrokingGreater5K / TopBrokingTotal) * 100;
  const TopBrokingG1K = (TopBrokingGreater1K / TopBrokingTotal) * 100;

  const topMtf = (TopMtfClient / TopMtfClient) * 100;

  const TotalCount =
    TopBrokingGreater15K +
    TopBrokingGreater10K +
    TopBrokingGreater5K +
    TopBrokingGreater1K;

  return (
    <div
      className={"tab-pane fade" + " " + active}
      id={id}
      role="tabpanel"
      aria-labelledby="year-tab"
    >
      <div className="row client-snapshot-wrapper">
        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
          <div className="card-box snapshot-card-box">
            <div className="card-subtitle">
              <h3>{Constants.Newly_Acquired_Clients}</h3>
            </div>
            <div className="chart-point total-chart-point">
              <p>{Constants.Traded_Client}</p>
              <h4>{Clientloader ? <SmallLoader /> : <>{AcqTradedClient}</>}</h4>
            </div>
            <div className="card-bottom-body">
              <div className="card-list row">
                <div className="chart-point">
                  <p>
                    <span className="bg-sky-blue" />
                    {Constants.MarginW}
                  </p>
                  <h4>
                    {Clientloader ? (
                      <SmallLoader />
                    ) : (
                      <>{AcqNotTradedWMargin}</>
                    )}
                  </h4>
                </div>
                <div className="chart-point">
                  <p>
                    <span className="bg-gray" />
                    {Constants.MarginWO}
                  </p>
                  <h4>
                    {Clientloader ? (
                      <SmallLoader />
                    ) : (
                      <>{AcqNotTradedWOMargin}</>
                    )}
                  </h4>
                </div>
              </div>
              <div className="chart-img">
                {/* <img src={NewClientChart} alt="" /> */}
                {/* {AcqNotTradedWMargin === 0 && AcqNotTradedWOMargin === 0 ? (
                  <img src={NodataFound} />
                ) : ( */}
                <ClientSnapshotGraph1
                  title={"Newly Acq"}
                  subTitle1={"Traded Client"}
                  subTitle2={"Not Traded W/Margin"}
                  subTitle3={"Not Traded W/O Margin"}
                  // tradedClient={ChartAcq}
                  tradedClientWmargin={ChartAcqNotWmargin}
                  tradedClientWOmargin={ChartAcqNotWOmargin}
                  // color={["#FF86B1", "#D3D3D3", "#61CFF2"]}
                />
                {/* )} */}
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
          <div className="card-box snapshot-card-box">
            <div className="chart-head">
              <div className="card-subtitle">
                <h3>{Constants.Inactive_Clients}</h3>
              </div>
              <div className="chart-point total-chart-point">
                <p>{Constants.Zero_OP_Clients}</p>
                <h4>
                  {Clientloader ? <SmallLoader /> : <>{InActiveZeroClient}</>}
                </h4>
              </div>
            </div>
            <div className="card-bottom-body">
              <div className="card-list row">
                <div className="chart-point">
                  <p>
                    <span className="bg-pink" />
                    {">"} {Constants.Thirty_Days}
                  </p>
                  <h4>
                    {Clientloader ? <SmallLoader /> : <>{InActiveGreater30D}</>}
                  </h4>
                </div>
                <div className="chart-point">
                  <p>
                    <span className="bg-sky-blue" />
                    {">"} {Constants.Sixty_Days}
                  </p>
                  <h4>
                    {Clientloader ? <SmallLoader /> : <>{InactiveGreater60D}</>}
                  </h4>
                </div>
                <div className="chart-point">
                  <p>
                    <span className="bg-gray" />
                    {">"} {Constants.Ninty_Days}
                  </p>
                  <h4>
                    {Clientloader ? <SmallLoader /> : <>{InActiveGreater90D}</>}
                  </h4>
                </div>
              </div>
              <div className="chart-img">
                {/* <img src={NewClientChart} alt="" /> */}
                <ClientSnapshotGraph2
                  title={"Inactive Clients"}
                  subTitle1={"Inactive > 30D"}
                  subTitle2={"Inactive > 60D"}
                  subTitle3={"Inactive > 90D"}
                  InactiveClient30={ChartInActiveG30D}
                  InactiveClient60={ChartInActiveG60D}
                  InactiveClient90={ChartInActiveG90D}
                  // color={["#FF86B1", "#D3D3D3", "#61CFF2"]}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
          <div className="card-box snapshot-card-box">
            <div className="card-subtitle">
              <h3>{Constants.Top_Broking_Clients}</h3>
            </div>
            <div className="chart-point total-chart-point">
              <p>{Constants.Zero_OP_Clients}</p>
              <h4>{Clientloader ? <SmallLoader /> : <>{TotalCount}</>}</h4>
            </div>
            <div className="card-bottom-body">
              <div className="card-list row">
                <div className="chart-point">
                  <p>
                    <span className="bg-pink" />
                    {">="} {Constants.Fifty_Thousand}
                  </p>

                  <h4>
                    {Clientloader ? (
                      <SmallLoader />
                    ) : (
                      <>{TopBrokingGreater15K}</>
                    )}
                  </h4>
                </div>
                <div className="chart-point">
                  <p>
                    <span className="bg-sky-blue" />
                    {">="} {Constants.Ten_Thousand}
                  </p>
                  <h4>
                    {Clientloader ? (
                      <SmallLoader />
                    ) : (
                      <>{TopBrokingGreater10K}</>
                    )}
                  </h4>
                </div>
                <div className="chart-point">
                  <p>
                    <span className="bg-gray" />
                    {">="} {Constants.Five_Thousand}
                  </p>
                  <h4>
                    {Clientloader ? (
                      <SmallLoader />
                    ) : (
                      <>{TopBrokingGreater5K}</>
                    )}
                  </h4>
                </div>
                <div className="chart-point">
                  <p>
                    <span className="bg-yellow" />
                    {">="} {Constants.One_Thousand}
                  </p>
                  <h4>
                    {Clientloader ? (
                      <SmallLoader />
                    ) : (
                      <>{TopBrokingGreater1K}</>
                    )}
                  </h4>
                </div>
              </div>
              <div className="chart-img">
                {/* <img src={NewClientChart} alt="" /> */}
                <ClientSnapshotGraph3
                  title={"Broking Clients"}
                  subTitle1={"Revenue >= 15K"}
                  subTitle2={"Revenue >= 10K"}
                  subTitle3={"Revenue >= 5K"}
                  subTitle4={"Revenue >= 1K"}
                  TopBrokingG15={TopBrokingG15K}
                  TopBrokingG10={TopBrokingG10K}
                  TopBrokingG5={TopBrokingG5K}
                  TopBrokingG1={TopBrokingG1K}
                  // color={["#FF86B1", "#D3D3D3", "#61CFF2"]}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
          <div className="card-box snapshot-card-box">
            <div className="card-subtitle">
              <h3>{Constants.Top_Clients_MTF}</h3>
            </div>
            <div className="card-bottom-body">
              <div className="card-list row">
                <div className="chart-point w-75">
                  <p>
                    <span className="bg-sky-blue" />
                    {Constants.Mtf_Client}
                  </p>
                  <h4>
                    {Clientloader ? <SmallLoader /> : <>{TopMtfClient}</>}
                  </h4>
                </div>
              </div>
              <div className="chart-img">
                {/* <img src={NewClientChart} alt="" /> */}
                {/* {TopMtfClient === 0 ? (
                  <img src={NodataFound} />
                ) : ( */}
                <ClientSnapshotGraph4
                  title={"Clients Mtf"}
                  subTitle1={"Mtf Client"}
                  TopMtfClient1={topMtf}
                />
                {/* )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientSnapshotContent;
